module.exports = __webpack_public_path__ + "img/logo.32da4ce8.png";